import api from "../ApiConfig";
import { Apis } from '../../config';
import { NotificationManager } from 'react-notifications';
import unauthService from "../unauth";



const CreateChat = async (data) => {
    try {
        const result = await api.post(`${Apis.GetAllChatPath}/create`, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        let response=JSON.parse(result.data)
        let parsedData=JSON.parse(response.body)
        if (!parsedData.success) {
            NotificationManager.error(parsedData.message);
            return null;
        }
        NotificationManager.success(parsedData.message, 'Success')
        return result;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in create chat:', error);
        NotificationManager.error('An error occurred while creating chat.');
        return null;
    }
};

const GetClientChatListPage = async (filterVal) => {
    try {
        const result = await api.get(`${Apis.GetAllChatPath}/all/?pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}&clientId=${filterVal.clientId}`, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return response.data 
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const DeleteClientChat = async (id) => {
    try {
        const result = await api.delete(Apis.GetAllChatPath+'/delete/'+id,  {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success(result.data.message);
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};
// chats
export default {
    CreateChat,
    GetClientChatListPage,
    DeleteClientChat
};